<template>
  <div v-if="show" class="logs_wrap">
    <div class='arch_log'>
      <date-picker
        v-model="date"
        type="datetime"
        range
        valueType="X"
        :confirm="true"
        @confirm="get_archive"
        :confirmText="translate('config.get_log')"
        :default-value="new Date().setHours(0, 0, 0, 0)"
        :disabled-date="disabledDate"
      >
       <template v-slot:input>
          <button
            id="datepicker-button-trigger"
            type="submit"
            class="mdi btn btn-info archive"
            :class="{ 'mdi-content-save mdi-archive': !loading }"
            :disabled="loading"
            >
            <scale-loader v-if="loading" height='9.5px' width='7.5px' margin='2px 2px 0.45px 2px'/>
             <span v-else> {{ translate('archive.one') }} </span>

          </button>
        </template>
      </date-picker>

      <div class="filters">
        <div class="filter">
          <label class="info"> {{ translate('log.time') }} </label>
          <sis-select
            class="select"
            v-model="params.timezone"
            :options="[{'label':'UTC', 'id': 'UTC'}, {'label':'Local Time', 'id': 'Local Time'}]"
            :searchable="false"
            :clearable="false"
            :show-labels="false"
            :close_on_select="true"
            :clear-on-select="false"
            :hide_selected="true"
          />
        </div>

        <div class="filter">
          <div class="info">
            {{this.translate('log.limit')}}
          </div>
          <label class="switch" @click.prevent="filters.limit = !filters.limit">
            <input type="checkbox" v-model="filters.limit">
            <span class="slider round"></span>
          </label>
        </div>

        <div class="filter">
          <div class="info">
            {{this.translate('log.only_warning')}}
          </div>
          <label class="switch" @click.prevent="filters.only_warning = !filters.only_warning">
            <input type="checkbox" v-model="filters.only_warning">
            <span class="slider round"></span>
          </label>
        </div>

        <div class="filter">
          <div class="info">
            {{this.translate('log.show_rssi')}}
          </div>
          <label class="switch" @click.prevent="filters.show_rssi = !filters.show_rssi">
            <input type="checkbox" v-model="filters.show_rssi">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

    </div>

    <TextTable
      :all_data = "all_data"
      :params = "params"
    />
  </div>
  <div
    v-else
    style="height: 100%"
  >
    <div class="spinner">
      <scale-loader />
    </div>
  </div>
</template>

<script>
import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';
import DatePicker from 'components/UIComponents/Datepicker2/index.js';

export default {
  name: 'Logs',
  components: {
    DatePicker,
    TextTable
  },
  props: ['dev_id'],
  data () {
    return {
      loading: false,
      show: false,
      temp: '',
      date: [],
      all_data: {},
      params: {
        timezone: 'Local Time'
      },
      filters:{
        limit: true,
        only_warning: false,
        show_rssi: false
      }
    }
  },

  watch: {
    $route () {
      this.show = false
      clearInterval(this.interval)
      this.check_params()
    },
    'filters.limit':{
      handler: function () {
        this.show = false
        clearInterval(this.interval)
        this.check_params()
      },
    },
    'filters.only_warning':{
      handler: function () {
        this.show = false
        clearInterval(this.interval)
        this.check_params()
      },
    },
    'filters.show_rssi':{
      handler: function () {
        this.show = false
        clearInterval(this.interval)
        this.check_params()
      },
    },
  },

  mounted () {
    this.check_params()
  },

  computed:{
    datetime_picker(){
      return this.$store.getters.getDatetimePicker
    }
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods: {
    check_params(){
      if (this.filters.utc) {
        this.params.timezone = this.filters.utc
      }

      let body = {format: 'array'}
      if (this.filters.limit) {
        body.limit = 1000
      }
      if (this.filters.only_warning) {
        body.type = "warnings"
      }

      body.show_rssi = this.filters.show_rssi

      this.request(body)
    },
    request(body){
      if (this.$route.name === 'device_section') {
        this.$http.v1.getDeviceLog(this.dev_id, body, (response) => {
          this.all_data = response.data
          this.show = true
        })
        this.interval = setInterval(() => {
          this.$http.v1.getDeviceLog(this.dev_id, body, (response) => {
            this.all_data = response.data
          })
        }, this.$store.getters.getDeviceLogUpdate)
      }
    },
    compareNumbers(a, b) {
      if (typeof(a[this.filter_type]) == 'string') {
        if (this.filter_asc === 'asc') {
          return a[this.filter_type] < b[this.filter_type] ? 1 : -1;
        }else{
          return a[this.filter_type] > b[this.filter_type] ? 1 : -1;
        }
      }else if (typeof(a[this.filter_type]) == 'number') {
        if (this.filter_asc === 'asc') {
          return a[this.filter_type] - b[this.filter_type]
        }else{
          return b[this.filter_type] - a[this.filter_type]
        }
      }
    },

    change_filter(type){
      if (this.filter_type === type) {
        if (this.filter_asc === 'asc') {
          this.filter_asc = 'desc'
        }else{
          this.filter_asc = 'asc'
        }
      }else{
        this.filter_type = type
      }
    },

    get_archive (selectedDate) {
        this.loading = true
      if (+selectedDate[0] !== 0) {
        this.$http.v1.saveDeviceLogs(this.dev_id, +selectedDate[0], +selectedDate[1], (response) => {
          let blob = new Blob([response.data])
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          let date1 = new Date(selectedDate[0]*1000)
          let date2 = new Date(selectedDate[1]*1000)
          link.download = 'Log' + '_' + this.dev_id + '_' + date1.getDate() + '.' + (date1.getMonth() + 1) + '.' + date1.getFullYear() + '—' + ((+date2 !== 0) ? + date2.getDate() + '.' + (date2.getMonth() + 1) + '.' + date2.getFullYear() : '') + '.txt'
          link.click()
          this.loading = false
        })
      }
    },
    disabledDate(date) {
      let today = new Date();
      return date > new Date(today.getTime()) || date < new Date(today.getTime() - this.datetime_picker * 24 * 3600 * 1000);
    },
  },
}

</script>
<style lang='scss'>
  .logs{
    &_wrap{
      display: flex;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      .response_table{
        padding: 5px 0;
        table{
          th{
            i{
              opacity: 0;
              width: 0;
              display: inline-block;
            }
            &.selected{
              color: #000;
              i{
                opacity: 1;
                width: auto;
              }
            }
          }
        }
      }
    }
    &_field{
      height: 100%;
      width: 100%;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 10px;
      }
    }
  }

  .mdi-arrow-down{
    transform: rotate(0);
    transition: 0.2s;
    &.reverse::before{
      transform: rotate(180deg);
    }
  }

  .log-panel{
    margin-bottom: 5px;
  }
  .archive {
    float: left;
  }
  .pointer{
    cursor: pointer;
  }

  .arch_log {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .mx-icon-calendar{
      display: none;
    }
    .mx-icon-clear{
      display: none;
    };

    .filters{
      display: flex;
      justify-content: center;
      align-items: center;

      .filter{
        display: flex;
        justify-content: center;
        align-items: center;
        // flex-direction: column;
        min-width: 150px;
        margin-right: 10px;

        .info{
          margin-right: 5px;
          text-transform: full-width;
          min-inline-size: max-content;
        }

        .select{
          margin: 0;
          width: 120px;
        }

        .switch {
          position: relative;
          display: inline-block;
          width: 45px;
          height: 22px;
          margin-bottom: 0;
        }
        .switch input {
          display:none;
        }
        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          -webkit-transition: .4s;
          transition: .4s;
        }

        .slider:before {
          position: absolute;
          content: "";
          height: 16px;
          width: 16px;
          left: 6px;
          bottom: 3px;
          background-color: white;
          -webkit-transition: .4s;
          transition: .4s;
        }

        input:checked + .slider {
          background-color: #41B883;
        }

        input:focus + .slider {
          box-shadow: 0 0 1px #41B883;
        }

        input:checked + .slider:before {
          transform: translateX(18px);
        }

        .slider.round {
          border-radius: 34px;
        }

        .slider.round:before {
          border-radius: 50%;
        }
      }
    }
  }

  @media (max-width:768px){
    .arch_log .filters{
      flex-wrap: wrap;
      justify-content: flex-end;
      .filter{
        justify-content: flex-end;
        margin-bottom: 5px;
      }
    }
  }
</style>
